


















import Vue from 'vue';
import $ from 'jquery';

import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { ModalSize } from '@/components/zen_modal/types';

import Task from './components/Task.vue';

export default Vue.extend({
  components: {
    Task,
    LoadingState,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    auditId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      task: null,
      openInServiceNowUrl: null,
      isLoaded: false,
      addingComment: false,
    };
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Large });
    $.get('/servicenow/get_task', { id: this.id, audit_id: this.auditId }).then(res => {
      this.updateTask(res);
      this.isLoaded = true;
    });
  },
  methods: {
    updateTask(res) {
      this.task = res.task;
      this.openInServiceNowUrl = res.openInServiceNowUrl;
    },
    addComment(newComment) {
      this.addingComment = true;

      const url =
        '/servicenow/task_add_comment?id=' +
        encodeURIComponent(this.id) +
        '&audit_id=' +
        encodeURIComponent(this.auditId);

      return $.ajax(url, {
        type: 'POST',
        data: JSON.stringify({
          comment: newComment,
        }),
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': window.GGRC.csrfToken },
      }).then(
        res => {
          this.updateTask(res);
          this.addingComment = false;
        },
        err => {
          window.GGRC.Notify({
            type: 'error',
            message: err,
          });
          throw err;
        }
      );
    },
  },
});
